/**
 * Where the portal's "Preview the member area" link lands.
 *
 * The portal has already proved who the person is, so unlike RedeemView
 * there is nothing to exchange — the token in the URL *is* the session.
 * It arrives in the fragment rather than the query string precisely because
 * a fragment is never sent to a server: it stays out of access logs, out of
 * CloudFront logs and out of the Referer header on the next request. It is
 * moved into local storage and stripped from the address bar immediately,
 * so a shared screenshot or a copied URL does not carry a live credential.
 */

import { useEffect } from 'preact/hooks';
import { useLocation } from 'wouter-preact';
import type { JSX } from 'preact';

import { setSession } from '../api.js';

export function PreviewView(): JSX.Element {
  const [, navigate] = useLocation();

  useEffect(() => {
    const token = window.location.hash.replace(/^#/, '').trim();
    if (token) {
      setSession(token);
      history.replaceState(null, '', window.location.pathname);
    }
    navigate(token ? '/account' : '/login', { replace: true });
  }, []);

  return (
    <main class="view centred">
      <p class="muted" role="status">Opening the member area…</p>
    </main>
  );
}
